import { Box, Grid } from "@mui/material"
import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { useMediaQuery } from "react-responsive"
import { useNavigate } from "react-router-dom"
import { SubMenuItem } from "./SubMenuItem"

interface Props {
  subMenu: any[]
  subMenuIndex: number
}

export const CommonLayout = ({ subMenu, subMenuIndex }: Props) => {
  const [subIndex, setSubIndex] = useState(subMenuIndex)

  const { t } = useTranslation("translation", { keyPrefix: "mypage.sidemenu" })
  const isTablet = useMediaQuery({ query: "(min-width: 1200px)" })

  const navigate = useNavigate()
  const onSubIndexSelected = (selected: number) => {
    setSubIndex(selected)
    navigate("/mypage" + getSubMenu(selected).link)
    //navigate(0)
  }

  const getSubMenu = (menuIndex: number) => {
    for (let i = 0; i < subMenu.length; i++) {
      if (subMenu[i].index == menuIndex) {
        return subMenu[i]
      }
    }
    return null
  }

  if (subMenu.length === 0) {
    return null
  }

  return (
    <>
      {isTablet ? (
        subMenu.length > 0 ? (
          <Box className="side_menu" sx={{ minWidth: "200px" }}>
            {subMenu.map((item: any) => (
              <SubMenuItem
                title={t(item.title)}
                key={`mySubMenu_${item.index}`}
                index={item.index}
                onClick={onSubIndexSelected}
                active={item.index == subIndex}
              />
            ))}
            {getSubMenu(subIndex).search}
          </Box>
        ) : (
          <></>
        )
      ) : (
        <></>
      )}

      {isTablet ? (
        <Box className="page_box">
          <Box className="page_content">{getSubMenu(subIndex).page}</Box>
        </Box>
      ) : (
        <Box display="block">
          <Box display="flex" sx={{ width: "100%", pr: "0px" }}>
            <Box display="block" sx={{ width: "100%" }}>
              {getSubMenu(subIndex).page}
            </Box>
          </Box>

          {subMenu.length > 0 ? (
            <Grid
              container
              sx={{
                mt: "0px",
                height: "60px",
                borderBottom: "1px dotted #D4D3D7",
                p: "0px",
                position: "absolute",
                bottom: "60px",
              }}
            >
              {subMenu.map((item: any, index: any) => (
                <SubMenuItem
                  key={`mySubMenu_${index}`}
                  title={t(item.title)}
                  icon={item.icon}
                  index={item.index}
                  subcount={subMenu.length}
                  onClick={onSubIndexSelected}
                  active={item.index == subIndex}
                />
              ))}
            </Grid>
          ) : (
            <></>
          )}
        </Box>
      )}
    </>
  )
}
